"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var reportPeriod_1 = require("../../common/helpers/reportPeriod");
var EcommerceDashboardController = /** @class */ (function () {
    function EcommerceDashboardController(ReportsModel) {
        this.ReportsModel = ReportsModel;
        this.dashboardData = null;
        this.loading = false;
        this.error = '';
        this.filters = __assign(__assign({}, (0, reportPeriod_1.defaultReportPeriod)()), { yoy_type: 'same_period', top_products_limit: 10 });
        this.onFilterChange = this.handleFilterChange.bind(this);
        this.fetchData();
    }
    EcommerceDashboardController.prototype.handleFilterChange = function (newFilters) {
        this.filters = newFilters;
        this.fetchData();
    };
    EcommerceDashboardController.prototype.fetchData = function () {
        var _this = this;
        this.loading = true;
        this.error = '';
        this.ReportsModel.getEcommerceDashboard(this.filters)
            .then(function (response) {
            _this.dashboardData = response.data;
            _this.loading = false;
        })
            .catch(function (err) {
            _this.error = 'Failed to load ecommerce dashboard data.';
            _this.loading = false;
        });
    };
    return EcommerceDashboardController;
}());
EcommerceDashboardController.$inject = ['ReportsModel'];
exports.default = EcommerceDashboardController;
